export default class RegistrosTabla {
  constructor(array) {
    if (!(array instanceof Array)) {
      throw new Error("Los registros han de ser un array");
    }

    this.array = array;
  }
}
